import { select } from 'redux-saga/effects'
import fetchDocumentSourceDetails from './fetchDocumentSourceDetails'

export default function * fetchAllDocumentSourcesDetails (action) {
  const { onEnd } = action.payload

  const state = yield select()

  const array = state.kanbo.documentSources.documentSources
  const length = array.length

  for (let i = 0; i < length; i++) {
    const documentSource = state.kanbo.documentSources.documentSourcesById[array[i]]
    if (documentSource && !documentSource.isReadable) {
      yield fetchDocumentSourceDetails({
        payload: {
          id: documentSource.id
        }
      })
    }
  }

  if (onEnd) onEnd()
}
